import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type MultiStepSportEventParticipantsFragment = {
	__typename?: 'MultiStepSportEvent';
	parent?: {
		__typename?: 'MultiStepSportEvent';
		id: string;
		content: {
			__typename?: 'MultiStepSportEventContent';
			name: string;
			fullPath?: string | null;
			startAt: any;
			status: Types.SportEventStatus;
		};
	} | null;
	content: {
		__typename?: 'MultiStepSportEventContent';
		startAt: any;
		competitionStage: {
			__typename?: 'SportCompetitionStageV2';
			name: Types.SportCompetitionStageName;
			number?: number | null;
		};
	};
};

export const MultiStepSportEventParticipantsFragmentDoc = gql`
	fragment MultiStepSportEventParticipants on MultiStepSportEvent {
		parent {
			id
			content(country: $country, language: $language) {
				name
				fullPath
				startAt
				status
			}
		}
		content(country: $country, language: $language) {
			competitionStage {
				name
				number
			}
			startAt
		}
	}
`;
